import React from "react";
import PropTypes from "prop-types";
import TickerIcon from "./TickerIcon";
import { useTickerName } from "./tickerData";
import "./Ticker.css";

/** [logo] SYMBOL company name — symbol inherits the parent's font. */
export default function TickerLabel({ symbol, size = 22 }) {
  const name = useTickerName(symbol);
  return (
    <span className="tkLabel">
      <TickerIcon symbol={symbol} size={size} />
      <span className="tkLabel__sym">{symbol}</span>
      {name && <span className="tkLabel__name" title={name}>{name}</span>}
    </span>
  );
}

TickerLabel.propTypes = {
  symbol: PropTypes.string.isRequired,
  size: PropTypes.number,
};
